// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

	// Window Scroll Event
	window.onscroll = function() {
		stickyHeader()
	};
	var header = document.getElementById("header");
	var sticky = header.offsetTop;
	function stickyHeader() {
		if (window.pageYOffset > sticky) {
			header.classList.add("sticky");
		} else {
			header.classList.remove("sticky");
		}
	}

	// Window Resize Event
	window.onresize = function() {
		positionBannerDivider()
	}
	function positionBannerDivider() {
		var bannerOverlay = document.querySelector('.banner-overlay');
		var bannerCurve = document.querySelector('#homebanner-curve');
		if (bannerOverlay == null || bannerCurve == null) return;
		bannerCurve.style.bottom = (bannerOverlay.offsetHeight - 1) + 'px';
	}
	positionBannerDivider();

} )();